import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Loader2, Send, CheckCircle, AlertCircle } from 'lucide-react';

const FORM_FIELDS = [
  { id: 'full_name', label: 'Full Name *', type: 'text', placeholder: 'Jane Doe' },
  { id: 'email', label: 'Email Address *', type: 'email', placeholder: 'jane@example.com' },
  { id: 'relationship', label: 'Relationship *', type: 'text', placeholder: 'e.g., Business Partner, Family Member', helper: 'Shared only with our review team — not with the recipient.' },
];

const IntroductionForm = ({ formData, handleChange, handleSubmit, sending, error, success, eligibility }) => {
  const atWeeklyLimit = eligibility?.rate_limits?.recent_introductions_7_days >= eligibility?.rate_limits?.max_per_week;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl">Send Private Introduction</CardTitle>
        <CardDescription>Introduce someone you trust to MyInvestFolio. They will receive a private invitation email from MyInvestFolio. Your identity and details about the relationship are kept confidential and never shared with the recipient.</CardDescription>
      </CardHeader>
      <CardContent>
        {success && (<Alert className="mb-6 bg-emerald-50 border-emerald-200"><CheckCircle className="h-4 w-4 text-emerald-600" /><AlertDescription className="text-emerald-800">{success}</AlertDescription></Alert>)}
        {error && (<Alert className="mb-6 bg-red-50 border-red-200"><AlertCircle className="h-4 w-4 text-red-600" /><AlertDescription className="text-red-800">{error}</AlertDescription></Alert>)}
        <form onSubmit={handleSubmit} className="space-y-6">
          {FORM_FIELDS.map(f => (
            <div key={f.id} className="space-y-2">
              <Label htmlFor={f.id}>{f.label}</Label>
              <Input type={f.type} id={f.id} name={f.id} value={formData[f.id]} onChange={handleChange} required placeholder={f.placeholder} />
              {f.helper && <p className="text-xs text-slate-500">{f.helper}</p>}
            </div>
          ))}
          <div className="space-y-2">
            <Label htmlFor="note">Rationale for this introduction (Optional)</Label>
            <Textarea id="note" name="note" value={formData.note} onChange={handleChange} placeholder="Briefly describe your relationship with this person and why you're introducing them to MyInvestFolio." rows={4} />
            <p className="text-xs text-slate-500">For our review team only. This is never shared with the recipient.</p>
          </div>
          <Button type="submit" disabled={sending || atWeeklyLimit} className="w-full bg-emerald-600 hover:bg-emerald-700 font-semibold py-6 text-lg">
            {sending ? (<><Loader2 className="mr-2 h-5 w-5 animate-spin" />Sending Introduction...</>) : (<><Send className="mr-2 h-5 w-5" />Send Private Introduction</>)}
          </Button>
          {atWeeklyLimit && <p className="text-sm text-orange-600 text-center">Weekly limit reached. You can send another introduction in a few days.</p>}
        </form>
      </CardContent>
    </Card>
  );
};

export default IntroductionForm;
